<template>
    <div>
        <div class="hidden" :class="{ 'w-screen fixed pin-t h-24 bg-black-transparent': searchIsFixed }"></div>
        <header :class="{ 'bg-grad-black-clear-b' : headerTransparent,
            'bg-black-transparent': !headerTransparent || menuIsOpen,
            'transition-bg-slow fixed' : headerIsFixed,
            'absolute': !headerIsFixed }"
            class="site-header pin-t w-full z-40 p-4 flex flex-row">
            <div class="flex items-center flex-grow">
                <router-link to="/" class="block w-32"
                    title="Home Page"
                    aria-label="Click here to go to the home page">
                    <SvgCarcLogo class="w-full block h-full"
                        role="img"
                        alt="The Certified Auto Repair Centers Logo" />
                </router-link>
                <BadgeASE class="ml-2"/>
            </div>
            <div class="flex-grow"></div> <!-- Empty div to push the items to the right -->
            <button v-if="!menuIsOpen"
                @click="toggleMenu()"
                class="flex items-center justify-end text-white z-50
                    sm:border-white rounded md:border-transparent hover:text-blue-light hover:border-blue-light"
                :class="{ 'bg-grey-darkest': screenSize.isSmall && !headerTransparent }">
                <span class="hidden sm:block pl-2 mr-2 z-60">Menu</span>
                <IconMenu viewBox="0 0 24 24" class="block h-15 w-15 mx-1 my-1 z-60" />
            </button>
        </header>
        <div v-if="menuIsOpen"
                class="menu pt-20 pin-t pin-r z-60 bg-black-transparent w-full xs:w-64"
                :class="{ 'fixed': headerIsFixed,
                    'absolute': !headerIsFixed }">
            <div class="flex-grow"></div> <!-- Empty div to push the items to the right -->
            <AppNavMain :headerTransparent="headerTransparent" :smallScreen="screenSize.isSmall" @closeMenu="toggleMenu()"/>
        </div>
    </div>
</template>

<script>
import AppNavMain from '@/js/components/AppNavMain.vue';
import SvgCarcLogo from 'svg/carc-logo.svg';
import BadgeASE from '@/js/components/BadgeASE.vue';
import IconMenu from 'icon/menu.svg';

export default {
    components: {
        AppNavMain,
        SvgCarcLogo,
        BadgeASE,
        IconMenu
    },
    props: {
        headerIsFixed: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data() {
        return {
            searchIsFixed: false,
            headerTransparent: false,
            menuIsOpen: false,
            screenSize: {
                isSmall: false,
                specificSize: ''
            }
        };
    },
    methods: {
        handleScroll() {
            if (this.headerIsFixed) {
                this.headerTransparent = window.scrollY < 80;
            }
        },
        handleResize() {
            if (window.innerWidth < 900) {
                this.screenSize.isSmall = true;
                if (window.innerWidth < 600) {
                    this.screenSize.specificSize = 'sm';
                } else {
                    this.screenSize.specificSize = 'xs';
                }
            } else {
                this.screenSize.isSmall = false;
                this.screenSize.specificSize = 'lg';
            }
        },
        toggleMenu() {
            this.menuIsOpen = !this.menuIsOpen;
        }
    },
    mounted() {
        this.handleResize();
        this.handleScroll();
        this.$root.$on('searchFixedTrue', () => { this.searchIsFixed = true; });
        this.$root.$on('searchFixedFalse', () => { this.searchIsFixed = false; });
    },
    created() {
        window.addEventListener('resize', this.handleResize);
        window.addEventListener('scroll', this.handleScroll);
    },
    destroyed() {
        window.removeEventListener('resize', this.handleResize);
        window.removeEventListener('scroll', this.handleScroll);
    }
};
</script>

<style>
</style>
